import type { BackendUser } from "./adminUsers";

export interface SFTPPublicKey {
  id: number;
  public_key: string;
  created_at: string;
}

export type SFTPAuthMode = "password" | "key" | "both";

export function resolveSftpAuthMode(c: {
  auth_mode?: SFTPAuthMode | string;
  has_password: boolean;
  has_keys: boolean;
}): SFTPAuthMode {
  const m = c.auth_mode;
  if (m === "password" || m === "key" || m === "both") return m;
  if (c.has_password && c.has_keys) return "both";
  if (c.has_keys) return "key";
  return "password";
}

export type SFTPConnectionSortBy =
  | "name"
  | "client_name"
  | "bucket_folder"
  | "created_at";

export interface SftpFolderMount {
  label: string;
  prefix: string;
  subfolders: string[];
  /** Physical subfolder name -> name shown over SFTP (Entry only; S3 unchanged). */
  subfolder_aliases?: Record<string, string>;
}

export interface SFTPConnection {
  id: number;
  user_id: number | null;
  client_name?: string | null;
  backend_user?: BackendUser | null;
  name: string;
  server_id: string;
  username: string;
  bucket: string;
  folder: string;
  role: string;
  subfolders: string[];
  folder_mounts?: SftpFolderMount[] | null;
  is_active: boolean;
  auth_mode?: SFTPAuthMode;
  public_keys: SFTPPublicKey[];
  has_password: boolean;
  has_keys: boolean;
  created_at: string;
  updated_at: string;
}

export interface SFTPConnectionsResponse {
  connections: SFTPConnection[];
}

export interface SFTPConnectionCreatePayload {
  user_id?: number | null;
  name?: string;
  server_id: string;
  username: string;
  password?: string;
  bucket?: string;
  folder?: string;
  role?: string;
  subfolders?: string[];
  folder_mounts?: SftpFolderMount[] | null;
  is_active?: boolean;
  auth_mode?: SFTPAuthMode;
  public_keys?: string[];
}

export type SFTPConnectionUpdatePayload =
  Partial<SFTPConnectionCreatePayload> & { id: number };
